import type { ReviewsPort, ReviewView } from './ports.ts';
import type { WorkerClient } from './worker.ts';

type Rows = { id: string; data: Record<string, unknown> }[];
type Query = (collection: string, options: { filters?: [string, '==', unknown][]; limit?: number }) => Promise<Rows>;

const text = (value: unknown) => (typeof value === 'string' ? value : '');

function reviewFromRecord(id: string, data: Record<string, unknown>): ReviewView {
  const avatar = text(data.buyerAvatar);
  return {
    id, rating: Math.min(5, Math.max(1, Math.round(Number(data.rating) || 1))), comment: text(data.comment),
    buyerName: text(data.buyerName) || 'A buyer', buyerPhotoUrl: avatar.startsWith('https://') ? avatar : null,
    createdAt: text(data.createdAt), reply: text(data.sellerReply) || null, replyAt: text(data.sellerReplyAt) || null,
  };
}

export function createReviews({ worker, query }: { worker: WorkerClient; query: Query }): ReviewsPort {
  return {
    // Reviews are filed under the shop owner's account (legacy and v2); v2
    // reviews also name the shop, so an owner's other shops are left out.
    async forShop(shop) {
      const rows = await query('reviews', { filters: [['sellerId', '==', shop.ownerId]], limit: 300 });
      return rows
        .filter(row => !row.data.shopId || row.data.shopId === shop.id)
        .map(row => reviewFromRecord(row.id, row.data))
        .sort((left, right) => right.createdAt.localeCompare(left.createdAt));
    },
    submit: async (orderId, rating, comment) => { await worker.call('submit_review', { orderId, rating, ...(comment ? { comment } : {}) }); },
    reply: async (reviewId, reply) => { await worker.call('reply_review', { reviewId, reply }); },
  };
}
